var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SnackbarActions } from '../actions';
/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
export var initialState = { show: false };
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SnackbarActions.SnackbarActionTypes.Open:
            return __assign({}, state, { show: true });
        case SnackbarActions.SnackbarActionTypes.Close:
            return __assign({}, state, { show: false });
        default: {
            return state;
        }
    }
}
